import React, { useState } from 'react';
import { TextField } from '@mui/material';
import RegularButton from 'components/CustomButtons/Button';
import { ColumnsAddedChip } from './ColumnsAddedChip';
import { useForm } from 'hooks/useForm';

export const InputColumns = (props) => {
  const { onSubmit } = props
  const { inputValues, handleInputOnChange, cleanForm } = useForm({
    column: ''
  })
  const { column } = inputValues
  const [alert, setAlert] = useState(false)
  const [columnsData, setColumnsData] = useState([])

  const handleAdd = (e) => {
    e.preventDefault()
    if(column.length === 0 ){
      setAlert(true) 
      return
    }
    setAlert(false)
    setColumnsData([...columnsData, column])
    cleanForm()
  }

  const handleRemove = (item) => {
    const newColumnns = columnsData.filter(col => col !== item)
    setColumnsData( newColumnns )
  }

  return (
    <>
    <form style={{ width: '100%' }} onSubmit={handleAdd}>
      <TextField
        fullWidth
        label={ alert ? 'Error! campo vacio' : 'Agregar Columna' }
        error={alert}
        variant="outlined"
        name="column"
        value={column}
        onChange={handleInputOnChange}
      />
    </form>
    <ColumnsAddedChip columns={columnsData} deleteCol={handleRemove}/>
    <RegularButton
      fullWidth
      color="facebook"
      tooltip="Generar"
      onClick={() => onSubmit(columnsData)}
      disabled={columnsData.length === 0 ? true : false}
    >
      Generar Columnas
    </RegularButton>
    </>
  )
}
